<template lang="html">
  <div class="row faq-page">
    <div class="col-md-12 text-left">
      <SmallHeader/>
      <div class="faq">
        <h3><a @click="$router.go(-1)"><img class="img-responsive" src="../assets/img/icons/back-button.svg" alt="Back Button"></a>{{translation.faq.pageTitle}}</h3>
        <div class="faq-container">
          <div v-for='(aq,idx) in faq'>
            <h5 :id="idx" :class="{ activeFaq: isSelected == idx }" @click="toggle(aq,idx)">
              {{aq.q}}
              <span class="arrow">
                <img  v-if="isSelected == idx" class="img-responsive" src="../assets/img/icons/blue-arrow.svg" alt="Back Button">
                <img  v-else class="img-responsive" src="../assets/img/icons/grey-arrow.svg" alt="Back Button">
              </span>
            </h5>
            <p v-show="isSelected == idx && isSelected != null">
              {{aq.a}}
            </p>
          </div>
        </div>
        <Footer/>
      </div>
      <div class="grey-paw">
        <img class="img-responsive" src="../assets/img/icons/grey-paws.svg" alt="Paw">
      </div>
      <div class="grey-paw-left">
        <img class="img-responsive" src="../assets/img/icons/grey-paws-left.svg" alt="Paw">
      </div>
      <div class="yellow-baloon">
        <img class="img-responsive" src="../assets/img/icons/yellow-baloon.svg" alt="Paw">
      </div>
    </div>
    <Cookies/>
  </div>
</template>
<script>
import SmallHeader from '../components/SmallHeader.vue'
import Footer from '../components/Footer.vue'
import Cookies from '../components/Cookies.vue'
export default {
  data(){
    return {
      translation: null,
      faq: message.faq.faq,
      isSelected: null
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
      this.faq = window.message.faq.faq;
    });
    this.translation = window.message;
    this.faq = window.message.faq.faq;
  },
  components: {
    SmallHeader,
    Footer,
    Cookies
  },
  methods: {
    toggle(aq,idx) {
      if(this.isSelected != idx){
        console.log(idx);

        this.isSelected = idx;
      }else{
        this.isActive = false;
      	this.isSelected = null;
      }
    },
  }
}
</script>
<style>

#app {
  background: linear-gradient(to bottom, #3057b0 0%, #4377c5 100%);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  min-height: 100%;
  min-width: 100%;
}
.faq {
  width: 60%;
  color: #fff;
  margin: 0 auto;
  margin-top: 3em;
}
.faq-container{
  background-color: #FFFFFF;
  color: #707070;
  border-radius: 1em;
  margin-bottom: 5em;
}
.faq-container div{
  border-bottom: 1px solid #707070;
}
.faq-container div:last-of-type{
  border-bottom: 0;
}
@font-face {
  font-family: 'Montserrat-Medium', sans-serif;
  src: url("../assets/fonts/Montserrat-Medium.woff") format("woff");
  font-display: swap;
}
h5{
  font-family: 'Montserrat-Medium', sans-serif;
  font-size: 1em;
  padding: 20px;
  position: relative;
}
h5 .arrow {
  position: absolute;
  display: inline-block;
  right: 1em;
}
h5:hover{
  cursor: pointer;
}
.faq p {
  background-color: #EEEEEE;
  padding: 20px;
  margin: 0;
}
.grey-paw{
  position: absolute;
  right: 0;
  top: 50%;
}
.grey-paw-left{
  position: absolute;
  left: 0;
  top: 35%;
}
.yellow-baloon{
  position: absolute;
  left: 0;
  top: 77%;
  width: 60px;
}
@font-face {
  font-family: 'Montserrat-Bold.woff',Helvetica, sans-serif;
  src: url("../assets/fonts/Montserrat-Bold.woff") format("woff");
  font-display: swap;
}
.activeFaq {
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.3);
  margin-bottom: 3px;
  color: #3057B0;
  font-family: 'Montserrat-Bold.woff',Helvetica, sans-serif;
}
@media (max-width: 768px) {
  .faq {
    width: 96%;
    margin-top: 1em;
  }
  .yellow-baloon{
    display: none;
  }
  .grey-paw{
    display: none;
  }
}
@media (max-width: 600px) {
  .grey-paw{
    position: absolute;
    right: 0;
    top: 6%;
    width: 4em;
  }
  .faq {
    width: 91%;
  }
}
</style>
